<template>
  <div>
    <h1>Submit Order</h1>
    <contact-form />
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import ContactForm from '@/components/SubmissionForm.vue';

@Component({
  components: {
    ContactForm,
  },
})
export default class PrintSubmission extends Vue {

}
</script>

<style scoped>

</style>
